import FocusAreasPanel from './FocusAreasPanel';

export default FocusAreasPanel;
